export default __webpack_public_path__ + "static/media/sy.b86ca545.svg";